import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { persistentStorage, STORAGE_KEYS } from '@/shared/utils/storage'

export const RAIL_WIDTH_DEFAULT = 248
export const RAIL_COLLAPSED_WIDTH = 72
export const RAIL_COLLAPSE_THRESHOLD = 140

interface LayoutState {
  railCollapsed: boolean
  railWidth: number
  drawerOpen: boolean
  inqListWidth: number
  /** 모바일 TopBar를 상세 화면 헤더로 바꿔 쓸 때의 제목/뒤로가기 (useStackHeader가 관리) */
  stackTitle: string | null
  stackBack: (() => void) | null
  setStackHeader: (title: string | null, onBack?: () => void) => void
  setRailCollapsed: (collapsed: boolean) => void
  toggleRail: () => void
  setDrawerOpen: (open: boolean) => void
  setInqListWidth: (width: number) => void
}

export const useLayoutStore = create<LayoutState>()(
  persist(
    (set) => ({
      railCollapsed: false,
      railWidth: RAIL_WIDTH_DEFAULT,
      drawerOpen: false,
      inqListWidth: 380,
      stackTitle: null,
      stackBack: null,
      setStackHeader: (stackTitle, onBack) => set({ stackTitle, stackBack: onBack ?? null }),
      setRailCollapsed: (railCollapsed) =>
        set({
          railCollapsed,
          railWidth: railCollapsed ? RAIL_COLLAPSED_WIDTH : RAIL_WIDTH_DEFAULT,
        }),
      toggleRail: () =>
        set((state) => {
          const nextWidth = state.railWidth < RAIL_COLLAPSE_THRESHOLD ? RAIL_WIDTH_DEFAULT : RAIL_COLLAPSED_WIDTH
          return {
            railCollapsed: nextWidth < RAIL_COLLAPSE_THRESHOLD,
            railWidth: nextWidth,
          }
        }),
      setDrawerOpen: (drawerOpen) => set({ drawerOpen }),
      setInqListWidth: (inqListWidth) => set({ inqListWidth }),
    }),
    {
      name: STORAGE_KEYS.LAYOUT,
      storage: persistentStorage,
      partialize: (state) => ({
        railCollapsed: state.railCollapsed,
        railWidth: state.railWidth,
        inqListWidth: state.inqListWidth,
      }),
    },
  ),
)
